import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/subject/list`, { params })
  return response.data
}

const getAllOnlySubj = async (data) => {
  const response = await AuthAPI.get(`/user/subject/list-only`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/user/subject/show/show/${data}`)
  return response.data
}

const createSubject = async (data) => {
  const response = await AuthAPI.post(`/admin/subject/create`, data)
  return response.data
}

const editSubject = async (data) => {
  const response = await AuthAPI.post(`/admin/subject/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/subject/delete/${data}`)
  return response.data
}

export const subjectService = {
  getAll,
  getAllOnlySubj,
  getOne,
  createSubject,
  editSubject,
  deleteOne,
}
